export default "__VITE_ASSET__Du9prZp3__"